
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {reduxForm, Field, SubmissionError} from 'redux-form'
import SlideContainer from 'components/SlideContainer'
import FormInput from 'components/FormInput'
import {updateUserProfile} from 'redux/modules/currentUser/actions'
import {closeModal} from 'redux/modules/ui/modal/actions'
import {getCurrentUser} from 'redux/modules/currentUser/selectors'
import isEmail from 'validator/lib/isEmail'
import ButtonsGroup from 'components/ButtonsGroup'
import customerImage from 'components/Icon/images/customer.svg'

export class EditProfileView extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    submitting: PropTypes.bool,
    error: PropTypes.string
  }

  render() {
    const {closeModal} = this.props

    return (
      <SlideContainer
        key='editProfile'
        className='edit-profile-view'
        title='Edit Profile'
        icon={customerImage}
        onCloseModal={closeModal}
      >
        <div className='edit-profile-view_content'>
          {this.renderForm()}
        </div>
      </SlideContainer>
    )
  }

  renderForm() {
    const {
      handleSubmit,
      invalid,
      submitting,
      closeModal
    } = this.props

    return (
      <form className='edit-profile-view_form' onSubmit={handleSubmit}>
        <Field
          name='name'
          label='Name'
          disabled={submitting}
          component={FormInput}
        />
        <Field
          name='email'
          label='Email'
          disabled={submitting}
          hint='This email address will be used to send any billing notices or information.'
          component={FormInput}
        />
        {this.renderError()}
        <ButtonsGroup className='edit-profile-view_form_buttons'>
          <button type='submit' disabled={submitting || invalid}>Save changes</button>
          <button type='button' onClick={closeModal}>Cancel</button>
        </ButtonsGroup>
      </form>
    )
  }

  renderError() {
    const {error} = this.props
    if (!error) return null

    return <div className='edit-profile-view_error'>{error}</div>
  }
}

const mapStateToProps = state => {
  return {
    initialValues: getCurrentUser(state)
  }
}

const form = reduxForm({
  form: 'editProfile',
  validate: ({name, email}) => {
    const errors = {}

    if (!name) {
      errors.name = 'Please provide your name'
    }

    if (!email) {
      errors.email = 'Email is required'
    } else if (!isEmail(email)) {
      errors.email = 'Incorrect email address'
    }

    return errors
  },
  onSubmit: (fields, dispatch) => new Promise((resolve, reject) => {
    dispatch(updateUserProfile(fields))
      .success(resolve)
      .fail(err => {
        reject(new SubmissionError({_error: err.message}))
      })
  })
})(EditProfileView)

export default connect(mapStateToProps, {closeModal})(form)



// WEBPACK FOOTER //
// ./client/modals/EditProfileView/index.js